// removed by extract-text-webpack-plugin
module.exports = {"inline":"InlineShell__inline___3nRz1","flash":"InlineShell__flash___1PLl6"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Shells/InlineShell.scss
// module id = 563
// module chunks = 0